import { matchHeight } from 'jquery-match-height';

export default function() {
  $('.articles__box__inner').matchHeight();
  $('.same__height').matchHeight();
}



// WEBPACK FOOTER //
// ./source/assets/javascripts/initMatchHeight.js